"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var inputVerification = {
  checkForNumberLimit: function checkForNumberLimit(min, max, value) {
    var parsedValue = parseInt(value, 10);
    if (parsedValue < min) {
      return min;
    }
    if (parsedValue > max) {
      return max;
    }
    return parsedValue;
  }
};
var _default = exports["default"] = inputVerification;